export default __webpack_public_path__ + "static/media/15a466da181a7f75da29a8a8520bf05f1579809309588.181e9ee4.webp";